<div class="current-lang-wrapper" matRipple matRippleColor="#ffffff18">{{locale.currentLanguage}}</div>

<div #optionsWrapper class="lang-list-wrapper" *ngIf="isSelectionOpen">
  <div #option
       (click)="locale.setLocale(lang)"
       (mouseenter)="selected = option"
       *ngFor="let lang of locale.availableLanguages"
       [class.active]="lang === locale.currentLanguage"
       [class.selected]="selected === option"
       class="lang-list-option" translate>languages.{{lang}}</div>
</div>
